import React from "react";
import { useShallow } from "zustand/react/shallow";
import { useEmissionAmbienteStore } from "stores/emissionAmbienteStore";
import { useAuth } from "context/AuthContext";

function ambienteLabel(ambiente) {
  if (String(ambiente || "").trim().toLowerCase() === "produccion") {
    return "Producción";
  }
  return "Certificación";
}

function statusLabel(status) {
  return String(status || "").trim().toLowerCase() === "active" ? "Activo" : "Inactivo";
}

export default function NavbarEmitterSwitcher() {
  const { isReadOnly } = useAuth();
  const emission = useEmissionAmbienteStore(
    useShallow((s) => ({
      kind: s.kind,
      profiles: s.profiles,
      profileUuid: s.profileUuid,
      rutEmisor: s.rutEmisor,
      setSelectedProfileUuid: s.setSelectedProfileUuid,
    })),
  );

  // Contador/solo-lectura: modo fijo en Producción, sin selector (no cambia de modo).
  if (isReadOnly) {
    const activeProfile = emission.profiles.find((p) => p.profileUuid === emission.profileUuid);
    return (
      <div className="flex min-w-0 max-w-[19rem] flex-col gap-1">
        <span className="truncate px-1 text-[10px] font-semibold uppercase tracking-[0.09em] text-gray-500 dark:text-gray-400">
          Emisor activo
        </span>
        <div
          title="Modo fijo: Producción (solo lectura)"
          className="flex w-full min-w-[10.5rem] max-w-[19rem] items-center gap-2 rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 text-xs font-medium text-navy-800 shadow-sm dark:border-white/15 dark:bg-navy-900 dark:text-white"
        >
          <span aria-hidden="true">🔒</span>
          <span className="truncate">
            {(activeProfile?.profileName || activeProfile?.internalId || "Emisor")}
            {" · "}
            {activeProfile?.rutEmisor || emission.rutEmisor || "—"}
            {" · Producción"}
          </span>
        </div>
      </div>
    );
  }

  const disabled = emission.kind !== "ready" || emission.profiles.length <= 1;

  return (
    <label className="flex min-w-0 max-w-[19rem] flex-col gap-1">
      <span className="truncate px-1 text-[10px] font-semibold uppercase tracking-[0.09em] text-gray-500 dark:text-gray-400">
        Emisor activo
      </span>
      <select
        value={String(emission.profileUuid || "")}
        onChange={(e) => emission.setSelectedProfileUuid?.(e.target.value)}
        disabled={disabled}
        className="w-full min-w-[10.5rem] max-w-[19rem] rounded-xl border border-gray-200 bg-white px-3 py-2 text-xs font-medium text-navy-800 shadow-sm transition hover:border-brand-300 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/15 dark:bg-navy-800 dark:text-white dark:hover:border-brand-400"
        title={
          disabled
            ? "No hay más emisores disponibles para cambiar."
            : "Selecciona el emisor DTE activo"
        }
      >
        {emission.profiles.map((p) => (
          <option key={p.profileUuid || `${p.id}`} value={p.profileUuid}>
            {(p.profileName || p.internalId || "Perfil sin nombre") +
              ` · ${p.rutEmisor || "sin RUT"} · ${ambienteLabel(p.ambiente)} · ${statusLabel(p.status)}`}
          </option>
        ))}
      </select>
    </label>
  );
}
